export const makeSpaceInNav = () => {
  const menu = document.querySelector(".header__menu-list"); // to jest UL z LI
  const logo = document.querySelector(".header__logo");      // <img> lub <a> z logo
  if (!menu || !logo) return;

  // Nie rób tego drugi raz
  if (menu.parentElement && menu.parentElement.classList.contains("nav-split")) return;

  // 1) Upewniamy się, że liczba elementów jest parzysta (spacer na początku gdy nieparzysta)
  let items = Array.from(menu.querySelectorAll("li"));

  if (!menu.querySelector(".menu-spacer") && items.length % 2 !== 0) {
    let spacer = document.createElement("li");
    spacer.classList.add("menu-spacer");
    spacer.innerHTML = "&nbsp;";
    if (document.querySelector(".home")) {
      menu.insertBefore(spacer, menu.firstChild);
    }
    else {
      let cta = document.querySelector("a");
      cta.classList.add("button");
      cta.innerHTML = "REZERWUJ STOLIK";
      spacer.innerHTML = '';
      spacer.appendChild(cta)
      menu.append(spacer);
    }

    items = Array.from(menu.querySelectorAll("li"));
  }



  const count = items.length;
  let middleIndex
  if (document.querySelector(".home")) {
    middleIndex = Math.floor(count / 2);
  }
  else {
    middleIndex = Math.floor(count / 2);
  }


  const leftItems = items.slice(0, middleIndex);
  const rightItems = items.slice(middleIndex);

  // 2) Budujemy nową strukturę:
  // <div class="nav-split">
  //   <div class="nav-left"><ul>...</ul></div>
  //   (logo jako rodzeństwo)
  //   <div class="nav-right"><ul>...</ul></div>
  // </div>
  const container = document.createElement("div");
  container.className = "nav-split";

  const leftWrap = document.createElement("div");
  leftWrap.className = "nav-left";
  const leftList = document.createElement("ul");
  leftList.className = "header__menu-list header__menu-list--left";

  const rightWrap = document.createElement("div");
  rightWrap.className = "nav-right";
  const rightList = document.createElement("ul");
  rightList.className = "header__menu-list header__menu-list--right";

  leftItems.forEach(li => leftList.appendChild(li));
  rightItems.forEach(li => rightList.appendChild(li));

  leftWrap.appendChild(leftList);
  rightWrap.appendChild(rightList);

  // Wstawiamy nowy kontener w miejsce starego UL
  menu.replaceWith(container);

  // Kolejność: left | logo | right (logo staje się rodzeństwem divów)
  container.appendChild(leftWrap);
  container.appendChild(logo);      // przenosimy istniejący element logo tutaj
  container.appendChild(rightWrap);


};
